import { isEmpty } from 'lodash';
import { useSessionStorage } from 'usehooks-ts';

import {
  RecordsWithTimestamp,
  SEARCH_HISTORY_KEY,
  VIEWED_RECORDS_KEY,
} from '@app/components';
import {
  UserSearchDto,
  useSaveRecentInstancesMutation,
  useSaveRecentSearchesMutation,
} from '@app/hooks';

export const useRecentActivityTransfer = () => {
  const [viewedInstances, setViewedRecords] = useSessionStorage<
    RecordsWithTimestamp[]
  >(VIEWED_RECORDS_KEY, []);
  const [searchHistory, setSearchHistory] = useSessionStorage<UserSearchDto[]>(
    SEARCH_HISTORY_KEY,
    []
  );
  const transferViewedRecordsMutation = useSaveRecentInstancesMutation();
  const transferSearchesMutation = useSaveRecentSearchesMutation();

  const transferRecentActivity = (systemId: string) => {
    if (!isEmpty(viewedInstances)) {
      transferViewedRecordsMutation.mutate(
        {
          viewedInstances,
          systemId,
        },
        { onSuccess: () => setViewedRecords([]) }
      );
    }

    if (!isEmpty(searchHistory)) {
      transferSearchesMutation.mutate(
        {
          searches: searchHistory,
          systemId,
        },
        { onSuccess: () => setSearchHistory([]) }
      );
    }
  };

  return {
    isLoading:
      transferSearchesMutation.isLoading ||
      transferViewedRecordsMutation.isLoading,
    transfer: transferRecentActivity,
  };
};
